export const GET_SHOP_CONFIG = "SHOP/GET_SHOP_CONFIG";
export const GET_SHOP_CONFIG_API_SUCCESS = "SHOP/GET_SHOP_CONFIG_API_SUCCESS";
export const GET_SHOP_CONFIG_API_FAILED = "SHOP/GET_SHOP_CONFIG_API_FAILED";
export const PUSH_CONFIG = "SHOP/PUSH_CONFIG";
